import { render, staticRenderFns } from "./BudgetChart.vue?vue&type=template&id=786f314a&"
import script from "./BudgetChart.vue?vue&type=script&lang=js&"
export * from "./BudgetChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports